import { render, staticRenderFns } from "./rejectpopup.vue?vue&type=template&id=a547324c&scoped=true&"
import script from "./rejectpopup.vue?vue&type=script&lang=js&"
export * from "./rejectpopup.vue?vue&type=script&lang=js&"
import style0 from "./rejectpopup.vue?vue&type=style&index=0&id=a547324c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a547324c",
  null
  
)

export default component.exports